import { render, staticRenderFns } from "./LoadingContactList.vue?vue&type=template&id=7905de4b&scoped=true&"
var script = {}
import style0 from "./LoadingContactList.vue?vue&type=style&index=0&id=7905de4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7905de4b",
  null
  
)

export default component.exports